<style rel="stylesheet/scss" lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700&display=swap');

  .leaflet-map-ac {
    display: block;
    position: absolute !important;
    width: 350px;
    height: auto;
    top: 15px;
    right: 15px;
    overflow: hidden;
    z-index: calc(var(--map-z-index) + 2);
    background-color: rgba(255,255,255,1);
    box-shadow: 0 0 27px -5px rgba(0,0,0,0.5);

    * {
      box-sizing: border-box;
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      font-weight: 400;
    }

    *:focus {
      outline: 0;
    }

    &__search {
      display: block;
      width: 100%;
      height: 55px;
      overflow-x: hidden;
      overflow-y: visible;
      transition : height 150ms ease-in-out, width 150ms ease-in-out;

      &__close {
        display: block;
        position: relative;
        height: 55px;
        width: 36px;
        border: none;
        background: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        appearance: none;
        float: left;
        cursor: pointer;

        &__icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 16px;
          fill: var(--map-accent-color);
          transition : fill 150ms ease-out;
        }

        &:hover &__icon {
          fill: #333333;
        }
      }

      &__field {
        position: relative;
        display: block;
        width: calc(100% - 37px);
        float: left;
        height: 55px;
        line-height: 55px;
        margin: 0;
        padding: 0 12px;
        border: none;
        font-size: 1.4em !important;
        font-weight: 300 !important;
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        appearance: none;
      }
    }

    &__results {
      display: block;
      width: 100%;


      &__result {
        display: block;
        width: 100%;
        padding: 14px 12px;
        border-top: 1px solid rgba(200,200,200,1);
        cursor: pointer;
      }
    }

  }
</style>

<template>
  <div
    ref="container"
    class="leaflet-map-ac">

    <div class="leaflet-map-ac__search">

      <input
        type="text"
        placeholder="Search for starting address..."
        class="leaflet-map-ac__search__field"
        contenteditable="true"
        v-model="address"
        @keyup="handleSearch"
        @keyup.enter.stop="handleClick(results[0])" />

      <button
        @click="handleClear"
        type="button"
        class="leaflet-map-ac__search__close">
        <i class="leaflet-map-ac__search__close__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/></svg>
        </i>
      </button>

    </div>

    <div
      v-if="results.length"
      class="leaflet-map-ac__results">

      <div
        v-for="result in results"
        :key="result.id"
        @click="handleClick(result)"
        class="leaflet-map-ac__results__result">
        {{ result.address }}
      </div>

    </div>

  </div>
</template>

<script lang="js">
  import Vue from 'vue';
  import notEmpty from '../utils/notEmpty';
  import {debounce} from 'lodash';
  import geo from '../services/geo';

  export default Vue.extend({
    name: 'autocomplete',
    props: {},
    filters: {},
    data() {
      return {
        address: '',
        selected: null,
        results: [],
      };
    },
    computed: {},
    methods: {
      notEmpty,
      handleSearch: debounce(function() {
        const vm = this;
        geo
          .post('/fuzzysearch', {
            text: this.address
          })
          .then(({data}) => data.data)
          .then(res => {vm.results = res.length ? res : []})
          .catch(console.error);
      }, 150),
      handleClick(selected) {
        this.$emit('showWaypoints', selected);
      },
      handleClear() {
        this.address = '';
        this.selected = null;
        this.results = [];
        this.$emit('closeAutocomplete');
      },
    },
    watch: {},
  });
</script>
